import { useState, useCallback, useEffect } from "react";

export function useToast() {
  const [toast, setToast] = useState(null);
  const show = useCallback((msg, type = "success") => setToast({ msg, type }), []);
  const hide = useCallback(() => setToast(null), []);
  return { toast, show, hide };
}

export function Toast({ msg, type, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 4000);
    return () => clearTimeout(t);
  }, [onClose]);

  const bg =
    type === "error" ? "#c0392b" :
    type === "warn"  ? "#e67e22" : "#27ae60";

  return (
    <div style={{
      position: "fixed", bottom: 24, right: 24, zIndex: 9999,
      background: bg, color: "#fff",
      padding: "12px 18px", borderRadius: 12,
      fontSize: 14, fontWeight: 500,
      fontFamily: "DM Sans, sans-serif",
      boxShadow: "0 8px 32px rgba(0,0,0,0.45)",
      animation: "slideUp .25s ease",
      display: "flex", alignItems: "flex-start", gap: 10,
      maxWidth: 340, lineHeight: 1.5,
    }}>
      <span style={{ flexShrink: 0, marginTop: 1 }}>
        {type === "error" ? "✕" : type === "warn" ? "⚠" : "✓"}
      </span>
      <span style={{ flex: 1 }}>{msg}</span>
      <button
        onClick={onClose}
        style={{ background: "none", border: "none", color: "#fff", cursor: "pointer", fontSize: 18, lineHeight: 1, flexShrink: 0, padding: 0, marginTop: -1 }}
      >×</button>
    </div>
  );
}
